export default __webpack_public_path__ + "static/AboutUs-00a1b887e2655428901c5eb13bd907b9.png";